import React from 'react';
import PropTypes from 'prop-types';
import { compose, withProps } from 'recompose';
import Button from '../../../../app/components/Button';
import { useTranslation } from 'react-i18next';

function BackToTopButton({ backToTop }) {
  const { t } = useTranslation();
  return (
    <Button
      className="pull-right"
      onClick={backToTop}
      icon="arrow-up"
    >
      {t("Tillbaka till toppen")}
    </Button>
  );
}

BackToTopButton.propTypes = {
  backToTop: PropTypes.func.isRequired,
};

export default compose(
  withProps({
    backToTop: () => window.scroll({ top: 0 }),
  }),
)(BackToTopButton);
